import { AnimatePresence, motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SectionHintBubbleProps {
  hint: string;
}

export const SectionHintBubble = ({ hint }: SectionHintBubbleProps) => {
  const { t } = useTranslation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={hint}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.2 }}
        className="rounded-lg border border-gray-300 bg-gray-50 px-3 py-2">
        <div className="flex items-start gap-2">
          <Lightbulb className="mt-0.5 size-4 shrink-0 text-gray-500" />
          <div className="flex-1">
            <p className="text-xs font-medium text-gray-800">
              {t('home:sectionGuidance.suggestion')}
            </p>
            <p className="mt-0.5 text-sm text-gray-700">{hint}</p>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
